import { useMemo, useState } from "react";
import { DataTable } from "@/composites/data-table/index";
import { useBodyStyles } from "./body.styles";
import { useContextSystemView } from "../../context/index";
import { LocalizationText } from "@/app/index";
import { SystemViewUserItemType } from "@/schemas/index";

export const BodyTable = () => {
  const [rowKey] = useState<keyof SystemViewUserItemType>("Id");

  const { styles } = useBodyStyles();
  const { controllerDataTable, selectedUserId, setSelectedUserId } =
    useContextSystemView();

  const columns: any = useMemo(
    () => [
      {
        dataIndex: "DisplayName",
        minWidth: 200,
        sorter: (a: any, b: any) =>
          a.DisplayName?.length - b.DisplayName?.length,
        title: (
          <LocalizationText value="system.view.search.table.column.name" />
        ),
      },
      {
        title: (
          <LocalizationText value="system.view.search.table.column.job.title" />
        ),
        sorter: (a: any, b: any) => a.JobTitle?.length - b.JobTitle?.length,
        minWidth: 160,
        dataIndex: "JobTitle",
      },
      {
        title: (
          <LocalizationText value="system.view.search.table.column.email" />
        ),
        sorter: (a: any, b: any) => a.Login?.length - b.Login?.length,
        minWidth: 160,
        dataIndex: "Login",
      },
      {
        title: (
          <LocalizationText value="system.view.search.table.column.mobile.phone" />
        ),
        sorter: (a: any, b: any) => a.WorkPhone?.length - b.WorkPhone?.length,
        minWidth: 160,
        dataIndex: "WorkPhone",
      },
    ],
    [],
  );

  return (
    <DataTable<SystemViewUserItemType>
      columns={columns}
      controller={controllerDataTable}
      searched={false}
      rowKey={rowKey}
      tableProps={{
        sticky: true,
        rowSelection: {
          type: "checkbox",
          hideSelectAll: true,
          selectedRowKeys: selectedUserId ? [selectedUserId] : [],
          onSelect: (record: any) => {
            setSelectedUserId((selectedUserId) =>
              record[rowKey] !== selectedUserId ? record[rowKey] : undefined,
            );
          },
        },
        onRow: (record: any) => ({
          className: styles.tableRow,
          onClick: () =>
            setSelectedUserId((selectedUserId) =>
              record[rowKey] !== selectedUserId ? record[rowKey] : undefined,
            ),
        }),
      }}
    />
  );
};
